module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACESURBVHgB7dqhEYBAEATBA4nBkX98OAwWgrj62nroDmHHbhUAAAAAAAAAX7VU07YfT/3YfZ2tDdciSoAwAcIECBMgTIAwAQAAAAAAAAbzC2ryC5qcAGEChAkQJkCYAGECAAAAAAAADOYX1OQXNDkBwgQIEyBMgDABwgQAAAAAAAAAgEFeZfAMLjqbtr4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/three-line.png
// module id = fspW
// module chunks = 2